<template>
  <div class="links">
    <router-link :to="{name: 'feedback_all'}" class="link-button" >Online spätná väzba</router-link>
    <router-link :to="{name: 'questionary_all'}" class="link-button">Dotazníky</router-link>
    <router-link :to="{name: 'videozone'}" class="link-button">Videozóna</router-link>
  </div>
</template>
<script>
export default {
  props: ["user", "courses"],
  data() {
    return {};
  },
  created: () => {},
  methods: {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackSidebar.vue